import { render, staticRenderFns } from "./TitleHeader.vue?vue&type=template&id=0d386b23&scoped=true"
import script from "./TitleHeader.vue?vue&type=script&lang=js"
export * from "./TitleHeader.vue?vue&type=script&lang=js"
import style0 from "./TitleHeader.vue?vue&type=style&index=0&id=0d386b23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d386b23",
  null
  
)

export default component.exports